export const REPORT_NOT_FOUND_POPUP_TITLE = 'Report is Being Uploaded';
export const NO_SYNCED_SESSIONS_TITLE = 'No synced sessions';
export const NO_SYNCED_SESSIONS_MSG =
	'Sync sessions on your desktop app with the Evinced Platform to allow peer collaboration and comparison over time. \nContact us for more details.';
export const REPORT_NOT_FOUND_POPUP_TEXT = "Refresh the page to view the report once it's ready.";
export const REPORT_NOT_FOUND_STATE_KEY = 'showReportNotFoundPopup';
